import { useContext, useEffect, useState } from "react";
import "./styles.css";
import SignUp from "./SignUp";
import VerifyOTP from "./VerifyOtp";
import { Box } from "@mui/material";
import CreatePin from "../Pincode/SetupPin/CreatePin";
import PINLogin from "./PINLogin";
import VerifyAccount from "./VerifyAccount";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { createUser, getUserFromId } from "../../../database/helpers/user";
import { useAuthContext } from "../../../context/AuthContext";

import { analytics, triggerLogEvent } from "../../../config/firebase";
import ConfirmationModal from "../../common/Modals/ConfirmationModal";
import { LanguageContext } from "../../../context/LanguageContext";
import { ACCOUNT_PIN_RESET } from "../../../apis/configuration";
import { handleApi } from "../../../apis";
import BusinessLoader from "../../common/BusinessLoader";

const SignUpScreen = () => {
  const [otpScreen, setIsOtpScreen] = useState({ phone: "", OTPresponse: {} });
  const [isOtpVerified, setIsOptVerified] = useState(false);
  const [accountLockedModal, setAccountLockedModal] = useState(false);
  const [accountSuspended, setAccountSuspended] = useState(false);
  const [KYCVerified, setKYCVerified] = useState(false);
  const [flagAccountScreen, setFlagAccountScreen] = useState(false);
  const [isFromForget, setIsFromForget] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpVerifiedResponse, setOtpVerifiedResponse] = useState({});
  const [OTP, setOTP] = useState("");
  const [loginStartTime, setLoginStartTime] = useState(null);
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const location = useLocation()
  const { setUser, setPinVerified } = useAuthContext();
  const isLockedAccount = location?.state?.isLockedAccount;
  const isVerifyAccountScreen = location?.state?.isVerifyAccountScreen
  const phoneNumber = location?.state?.phoneNumber;
  useEffect(() => {
    const forgotPinData = sessionStorage.getItem("forgotPinVerify");
    if (forgotPinData) {
      sessionStorage.removeItem("forgotPinVerify");
      const { phone } = JSON.parse(forgotPinData);
      setFlagAccountScreen(true);
      setIsFromForget(true);
      if (phone) setIsOtpScreen((e) => ({ ...e, phone }));
      return;
    }
    if (isLockedAccount && phoneNumber) {
      setAccountLockedModal(isLockedAccount)
      setIsOtpScreen((e) => ({ ...e, phone: phoneNumber }))
    }
    if (isVerifyAccountScreen) {
      setFlagAccountScreen(true)
      setIsFromForget(true);
      navigate("/", {
        replace: true,
        state: null,
      });
    }
  }, [isVerifyAccountScreen, isLockedAccount])
  useEffect(() => {
    if (!loginStartTime) {
      const startTime = new Date().getTime();
      setLoginStartTime(startTime);
    }
    return () => {
      if (loginStartTime) {
        const endTime = new Date().getTime();
        const timeSpent = (endTime - loginStartTime) / 1000;
        triggerLogEvent(analytics, "login_time_spent", {
          timeSpentInSeconds: timeSpent,
        });
      }
    };
  }, [loginStartTime]);

  const handleSubmitPIN = async (data) => {
    if (
      otpVerifiedResponse?.token &&
      otpVerifiedResponse?.old_user_id &&
      otpVerifiedResponse?.success
    ) {
      let paramsForUser = {
        telco_network: "",
        phone_number: otpScreen?.phone,
        id: otpVerifiedResponse?.old_user_id,
        is_active: true,
      };

      getUserFromId(paramsForUser?.id).then(async (user) => {
        if (user.length) {
          user = user[0];
          if (!user.is_active) user = await user.activateUserOnly();
          setPinVerified(true);
          setUser(user);
          navigate("/dataRestore");
        } else {
          createUser(paramsForUser).then(() => {
            getUserFromId(paramsForUser?.id).then(async (user) => {
              if (user.length) {
                setPinVerified(true);
                setUser(user[0]);
                navigate("/dataRestore");
              }
            });
          });
        }
      });
    }
  };
  const handleLockedAccount = (isSuspended) => {
    if (isSuspended)
      setAccountSuspended(true);
    else
      setAccountLockedModal(true);
  };
  const checkUserKYCVerified = async () => {
    try {
      setLoading(true);
      const response = await handleApi(
        ACCOUNT_PIN_RESET,
        { phone_number: otpScreen?.phone },
        null,
        navigate,
        { "Api-Key": process.env.REACT_APP_API_KEY },
      );
      const isVerified = response?.verified;
      setAccountLockedModal(false);
      if (isVerified) {
        setFlagAccountScreen(true);
      } else navigate("/ForgotPin", { state: { phone: otpScreen?.phone } });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    Cookies.remove("tempUserId");
    triggerLogEvent(analytics, "login_discovered");
  }, []);

  const backToLogin = () => {
    setIsOptVerified(false);
    setOTP("");
    setIsOtpScreen({ phone: "", OTPresponse: {} });
    setAccountLockedModal(false);
    setKYCVerified(false);
    setFlagAccountScreen(false);
    setIsFromForget(false);
    setOtpVerifiedResponse({});
  };

  const isCreatePINScreen =
    isOtpVerified && !otpScreen.OTPresponse.pin_required;
  const isVerifyOTPScreen =
    !isOtpVerified &&
    otpScreen?.OTPresponse?.otp_sent &&
    otpScreen?.OTPresponse?.otp_required;
  const isPINLoginScreen =
    (isOtpVerified || !otpScreen?.OTPresponse?.otp_required) &&
    otpScreen?.OTPresponse?.pin_required;

  return (
    <Box className="signUpWrapper">
      <BusinessLoader loadBusiness={loading} />
      <ConfirmationModal
        open={accountLockedModal}
        onClose={backToLogin}
        onConfirm={checkUserKYCVerified}
        message={(otpScreen?.OTPresponse?.data?.account_status === "suspended" || otpScreen?.OTPresponse?.data?.account_status === "locked") ? I18n.account_locked : I18n.too_many_incorrect_attempts}
        title={otpScreen?.OTPresponse?.data?.message || I18n.pin_entry_has_been_temporarily_locked_after_3_incorrect_attempts}
        confirmText={`${I18n.verify} ${I18n.phone_number}`}
        cancelText={I18n.cancel}
        id="too_many_request_modal"
        confirmButtonClassName="ubPrimaryButton"
      />
      {accountSuspended ?
        <VerifyAccount phone={otpScreen?.phone} backToLogin={backToLogin} isSuspended={true} /> :
        flagAccountScreen ? (
          <VerifyAccount phone={otpScreen?.phone} backToLogin={backToLogin} isFromForget={isFromForget} />
        ) : isCreatePINScreen ? (
          <CreatePin
            handleCancel={backToLogin}
            handleSetPINSuccess={handleSubmitPIN}
          />
        ) : isVerifyOTPScreen ? (
          <VerifyOTP
            sendOTPResponse={otpScreen.OTPresponse}
            phone={otpScreen?.phone}
            handleVerifyOTP={(data) => {
              setIsOptVerified(Boolean(data?.success));
              setOtpVerifiedResponse(data);
            }}
            setOTP={setOTP}
            backToLogin={backToLogin}
            handleLockedAccount={handleLockedAccount}

          />
        ) : isPINLoginScreen ? (
          <PINLogin
            OTP={OTP}
            otpScreen={otpScreen}
            handleSendOtpFailure={(OTPresponse, phone) =>
              setIsOtpScreen({ OTPresponse, phone })
            }
            onHandleVerifyScreen={() => { setIsFromForget(true); setFlagAccountScreen(true) }}
            resendOTPSuccess={(data) => {
              setIsOtpScreen(data);
              setIsOptVerified(false);
            }}
            handleLockedAccount={handleLockedAccount}
          />
        ) : (
          <SignUp
            handleSendOtpSuccess={setIsOtpScreen}
            handleSendOtpFailure={(OTPresponse, phone) =>
              setIsOtpScreen({ OTPresponse, phone })
            }
            hasLockedAccount={handleLockedAccount}
          />
        )}
    </Box>
  );
};

export default SignUpScreen;
